import React from "react";
import { Typography } from "../../Typography";
import { getProgressCircleSizeStyles, getProgressLabelSizes, showOutsideLabel } from "./helpers";
import * as S from "./styled";
import { ProgressCircleProps } from "./types";

const internalLabelClipStyles: React.CSSProperties = {
    width: "100%",
    textAlign: "center",
    overflow: "hidden",
    textOverflow: "clip",
    transition: "color 150ms ease-in-out"
};

type ProgressCircleInsideLabelsProps = Required<Pick<ProgressCircleProps, "size" | "labelColor" | "sublabelColor">> & {
    label: string;
    sublabel: ProgressCircleProps["sublabel"];
};

/**
 * @internal
 */
const ProgressCircleInsideLabels = ({
    size,
    label,
    labelColor,
    sublabel,
    sublabelColor
}: ProgressCircleInsideLabelsProps): JSX.Element => {
    const labelSizes = getProgressLabelSizes(size);
    const { size: styleSize, strokeWidth } = getProgressCircleSizeStyles(size);

    const maxLabelSize: number = styleSize - strokeWidth * 2;

    return (
        <S.ProgressCircleInsideLabelsWrapper
            spacing={0.5}
            column
            alignItems="center"
            justifyContent="center"
            maxWidth={maxLabelSize}
            maxHeight={maxLabelSize}
        >
            {sublabel !== undefined && !showOutsideLabel(size) && (
                <Typography
                    as="span"
                    variant={labelSizes.sublabel}
                    color={sublabelColor}
                    styles={internalLabelClipStyles}
                >
                    {sublabel}
                </Typography>
            )}
            <Typography as="span" variant={labelSizes.label} color={labelColor} styles={internalLabelClipStyles}>
                {label}
            </Typography>
        </S.ProgressCircleInsideLabelsWrapper>
    );
};

export default ProgressCircleInsideLabels;
